import {Injectable} from '@angular/core';
import {AmplifyService} from 'aws-amplify-angular';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ImageService {

  private imageDetails = {};
  private bookDetails: any;
  appHasFlash = true;

  // tslint:disable-next-line:variable-name
  constructor(private _amplifyService: AmplifyService,
              private httpClient: HttpClient) {
  }

  setBookDetails(bookDetails): void{
    this.bookDetails = bookDetails;
  }

  getBookDetails(): object {
    return this.bookDetails;
  }

  setImageDetails(imageDetails): void{
    Object.assign(this.imageDetails, imageDetails);
  }

  getImageDetails(): object {
    return this.imageDetails;
  }

  searchImage(byteArr): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/octet-stream'});
    return this.httpClient.post(environment.microservices_url, byteArr, {headers});
  }

  fetchImageDetails(payload): Observable<any> {
    const method = 'POST';
    const body = payload;
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.httpClient.post(environment.fetchmarker_url, payload, {headers});
  }

}
